__turbopack_context__.v({
  "box": "e5FZ9W_box",
  "boxDisabled": "e5FZ9W_boxDisabled",
  "icon": "e5FZ9W_icon",
  "iconDisabled": "e5FZ9W_iconDisabled",
  "wrapButton": "e5FZ9W_wrapButton",
  "wrapButtonDisabled": "e5FZ9W_wrapButtonDisabled",
});
